import {CanMatchFn} from '@angular/router';

const allowedFixtureStates = new Set(['populated', 'empty', 'error', 'loading']);
const allowedFixturePaths = new Set(['/ai/product-card-analytics']);

export function isProductCardAnalyticsVisualFixtureUrl(href: string): boolean {
  const url = new URL(href);
  const isLocalHost = ['localhost', '127.0.0.1', '[::1]', '::1'].includes(url.hostname);
  const fixtureState = url.searchParams.get('productCardAnalyticsVisualFixture') || '';

  return isLocalHost && allowedFixturePaths.has(url.pathname) && allowedFixtureStates.has(fixtureState);
}

export const productCardAnalyticsVisualFixtureCanMatch: CanMatchFn = () => {
  if (typeof window === 'undefined' || !window.location) return false;

  return isProductCardAnalyticsVisualFixtureUrl(window.location.href);
};
